import { css } from '@bts-web/utils-style-engine';
import { initServerTranslation } from '@bts-web/utils-lokalise';
import { TFunction } from 'i18next';
import { getRiskWarningsTranslations } from '../../asset-details/components/sections/CoolOffPeriod/utils/RiskWarningsTranslations';
import { UK_RISK_SUMMARY_URL } from '../../config/links';

const bannerStyles = css({
  position: 'sticky',
  // 0 on mobile (sticks at top of viewport); 72px on desktop (sticks just below the fixed header bar)
  top: { base: 0, lg: '72px' },
  zIndex: 3,
  width: '100%',
  backgroundColor: 'neutrals.fill_quinary',
  borderBottom: '1px solid',
  borderBottomColor: 'neutrals.stroke_secondary',
  px: 'medium',
  py: 'extra_small',
});

const textStyles = css({
  fontSize: 'caption.medium_medium',
  fontWeight: 'caption.medium_medium',
  color: 'neutrals.text_primary',
});

const linkStyles = css({
  fontWeight: 'caption.medium_bold',
  color: 'neutrals.text_primary',
  textDecoration: 'underline',
});

export const UKRiskWarningBanner = async () => {
  const { t } = await initServerTranslation();

  const translations = getRiskWarningsTranslations(t as TFunction);

  return (
    <div className={bannerStyles} data-testid="uk-risk-warning-banner">
      <p className={textStyles}>
        {translations.riskWarning1} {translations.riskWarning2}{' '}
        <a
          href={UK_RISK_SUMMARY_URL}
          target="_blank"
          rel="noopener noreferrer"
          className={linkStyles}
        >
          {translations.riskWarningTakeMinutes}
        </a>
      </p>
    </div>
  );
};
